export default "__VITE_ASSET__CTs4BMDR__"